// extracted by mini-css-extract-plugin
export default {"container":"Body_container__Rs+m9","heading":"Body_heading__xQv6c","toolbar":"Body_toolbar__jECKj","main":"Body_main__dqx11"};